import React from 'react';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { Flex, FixedFlex, RelativeBox, MainActionButton } from '../../../ui';
//////////////////////////////////////////////////

const buttonStyles = {
  width: 150,
  background: 'none',
  border: '1px solid',
  textTransform: 'uppercase',
};

const ErrorMessage = ({ error, handleClose }) => {
  const { message } = error;

  if (G.isNilOrEmpty(message)) return null;

  return (
    <RelativeBox
      p={20}
      pl={30}
      bg='white'
      height='100vh'
      overflow='auto'
    >
      <Flex height='100%' fontSize={20} justifyContent='center'>
        {message}
      </Flex>
      <FixedFlex
        pl={70}
        left='0px'
        bg='white'
        zIndex={12}
        bottom='0px'
        width='100%'
        p='14px 20px'
        boxShadow='0 0 8px 0 rgb(0 0 0 / 20%)'
      >
        <MainActionButton
          {...buttonStyles}
          mr={20}
          type='button'
          onClick={handleClose}
          color='greyMatterhorn'
          borderColor='greyMatterhorn'
        >
          {G.getWindowLocale('actions:close', 'Close')}
        </MainActionButton>
      </FixedFlex>
    </RelativeBox>
  );
};

export default ErrorMessage;
